<mat-dialog-content>
  <div class="close-wrapper">
    <div [class.icon-close-blue--rtl]="isRTL" class="btn-close close" (click)="closeDialog()">
      <span class="cmx-icon-close icon-close-blue"></span>
    </div>
  </div>
  <pcm-component [url]="pcmUrl" (onCodeSelected)="closeDialog($event)"></pcm-component>
</mat-dialog-content>
